/** Preserve cents when present; exact offer and alert amounts must agree. */
export const formatOfferPrice = (price: number) =>
  `$${price.toLocaleString('en-US', {
    minimumFractionDigits: Number.isInteger(price) ? 0 : 2,
    maximumFractionDigits: 2,
  })}`
